module.exports = __webpack_public_path__ + "static/commuters-b8a062b3e5c70c7c680d423c550a3470.svg";